import { allTrue, makeSafeFn } from '../../utils/fn'
import { domainFromFqdn, getIsMobile, getIsNativeApp } from '../../utils/ua'
import { info } from '../../application/console'
import { queryString as qs } from '../../utils/window'
import { isSupportedForDomain, getIsSlideshow } from '../../application/pageDataObject'

const FEATURE_ID = 'HeaderBidder'
export const HB_NAMESAPCE = 'headertag'
export const HB_MS_TIMEOUT = 2 // if 0 or false dfp wont start
const IS_HB_ALLOWED_IN_ALL_COUNTRY_CODES = true
const HB_SCRIPT_BY_DOMAINS = {
  '12up': 'https://js-sec.indexww.com/ht/p/184533-181801739077362.js',
  '90min': 'https://js-sec.indexww.com/ht/p/184533-118030064613115.js',
  floor8: 'https://js-sec.indexww.com/ht/p/184533-236796720006866.js',
  dbltap: 'https://js-sec.indexww.com/ht/p/184533-153233836086166.js',
  german_site: 'https://js-sec.indexww.com/ht/p/184533-118030064613115.js',
  theduel: 'https://js-sec.indexww.com/ht/p/184533-36721899497143.js',
}
const FEATURE_FLAGS = {
  forceHb: qs.forceHb,
  debug: qs.debugHb,
}

export function debug() {
  if (FEATURE_FLAGS.debug) {
    info('[HEADER-BIDDING]', ...arguments)
  }
}

function isHbAlreadyLoaded(hbNamespace) {
  return hbNamespace in window
}

function getHbScriptUrlByDomain() {
  return HB_SCRIPT_BY_DOMAINS[domainFromFqdn()]
}

function shouldLoadHb(countryCode) {
  if (isHbAlreadyLoaded(HB_NAMESAPCE)) {
    debug('already loaded, not loading again')
    return false
  }
  const predicates = [
    IS_HB_ALLOWED_IN_ALL_COUNTRY_CODES,
    isSupportedForDomain(FEATURE_ID),
    !getIsNativeApp(),
  ]
  const shouldLoad = FEATURE_FLAGS.forceHb || allTrue(...predicates)
  debug('isHbEnabled?', shouldLoad, { predicates, countryCode, isMobile: getIsMobile() })
  return shouldLoad
}

function delayPromiseChain(resolve, value, delay) {
  if (delay) {
    debug(
      `resolving with ${delay}ms timeout from inside "${HB_NAMESAPCE}.jsLoaded", starting "${delay}ms" timer until dfp script.`
    )
    setTimeout(function resolveDelayedHeaderBidder() {
      debug(`${delay}ms delay complete, resolving promise.`)
      resolve(value)
    }, delay)
  }
}

const headerBidderScriptConfig = {
  src: getHbScriptUrlByDomain,
  shouldLoad: shouldLoadHb,
  afterLoad: delayPromiseChain,
}

export default headerBidderScriptConfig



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/headerBidderScriptConfig.js